/* eslint-disable */
export default {
  toolbarHeight: '50px',
  toolbarButtonColor: '#CDCDCD',

  thumbnailHeight: '125px',
  thumbnailHeightFullscreen: '200px',
  thumbnailDrawerBackgroundColor: 'rgba(0, 0, 0, 0.9);',
  thumbnailSelectedColor: '#005DAC',
};
